<template>
  <div>
    <div class="jumbotron jumbotron-header">
      <div class="container">
        <h1 class="favorites-page-header"><i class="fa fa-heart fa-3x header-heart" aria-hidden="true"/>Your Favorites</h1>
        <p class="lead favorites-page-subheader">Content that you have favorited on our site will appear here</p>
      </div>
    </div>
    <div class="container">
      <span v-if="!loaded" class="gb-text-2 text-muted"><i class="fa fa-circle-o-notch fa-spin fa-fw"/>Loading Favorites...</span>
      <div class="row" v-if="loaded">
        <div class="col-md-8">
          <goal-favorites :goals="goals"/>
        </div>
        <div class="col-md-4">
          <strategy-favorites :strategies="strategies"/>
        </div>
      </div>

      <submit-feedback type="Favorites" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GoalFavorites from '@/components/favorites/GoalFavorites'
import StrategyFavorites from '@/components/favorites/StrategyFavorites'
import SubmitFeedback from '@/components/SubmitFeedback'

export default {
  name: 'FavoritesPage',
  components: {
    GoalFavorites,
    StrategyFavorites,
    SubmitFeedback
  },
  data: function() {
    return {}
  },
  computed: {
    ...mapState({
      userId: state => state.user.user.uuid,
      strategies: state => state.favorites.strategies,
      goals: state => state.favorites.goals,
      loaded: state => state.favorites.loaded
    })
  },
  watch: {
    userId: function() {
      this.retrieveFavorites()
    }
  },
  methods: {
    retrieveFavorites: function() {
      if (this.userId && this.userId.length > 0) {
        this.$store.dispatch('favorites/fetchPageContent', this.userId)
      }
    }
  },
  created: function() {
    this.retrieveFavorites()
    this.$sendEvent('Viewed Favorites Page')
  }
}
</script>

<style scoped lang="less">
@import '~@/mixins.less';
.header-heart {
  color: #b71429;
  font-size: 1em;
  margin-right: 16px;
}
.favorites-page-header {
  font-size: 56px;
}
.favorites-page-subheader {
  margin-left: 72px;
}
</style>
